export default {
  name: 'TsCardWrapper',
  functional: true,
  render(h, context) {
    return (
      <div {...{ class: ['p-15', context.data.staticClass] }}>
        {context.children}
      </div>
    )
  }
}
